if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === "true") return;
      this.dataset.bound = "true";

      const select = this.querySelector("[data-localization-select]");
      if (!select) return;

      select.addEventListener("change", (e) => {
        const value = e.target.value;
        const form = select.closest("[data-localization-form]");
        if (!form) return;

        const input = form.querySelector("input[data-localization-input]");
        if (input) {
          input.setAttribute("value", value);
          form.submit();
        }
      });
    }
  }
  customElements.define("m-localization-form", MLocalizationForm);
}
